export const inputgroupaddon = {
  root: ({ attrs }: Record<string, any>) => ({
    class: [
      // Flex
      'flex items-center justify-center',

      // Shape
      'first:rounded-l-lg',
      'last:rounded-r-lg',
      'border-y',

      'last:border-r',
      'border-l',
      'border-r-0',

      // Space
      'p-2',

      // Size
      'min-w-[2.5rem]',

      // Color
      'bg-white',
      'text-grey-400',
      {
        'border-grey-300': !attrs.hasError,
        'border-red': attrs.hasError,
      },
    ],
  }),
};
